import React, { useMemo, FunctionComponent } from 'react';
import { MarkdownField } from '@modules/utilities/types';
import MDXMarkdown from '@modules/ui/markdown/components/MDXMarkdown';
import aliasComponents from '@modules/ui/markdown/constants/aliasComponents';
import customComponents from '@modules/ui/markdown/constants/customComponents';
import { getMDXComponent } from '@rbx/docsite-utilities/dist/browser';

export type TArticleProps = {
  content: string | MarkdownField;
};

const Article: FunctionComponent<React.PropsWithChildren<TArticleProps>> = (props) => {
  const { content } = props;
  const contentComponent = useMemo(() => {
    if (typeof content === 'string') {
      const Component = getMDXComponent(content);
      return <Component components={{ ...aliasComponents(), ...customComponents }} />;
    }
    // NOTE (@mbae, 05/30/24): React 18 migration, couldn't figure out why this type was complaining
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return <MDXMarkdown>{content as any}</MDXMarkdown>;
  }, [content]);

  return contentComponent;
};

export default Article;
